export default "__VITE_ASSET__962092d2__"